<template>
  <teleport to="body">
    <div :class="fadeTransition" class="modal">
      <div :class="bounceTransition" class="modal-body">
        <div class="close-svg" @click="closeModal">
          <CloseSVG :propId="'print-close'" :fillColor="'#f7f9fc'" />
        </div>
        <h1 class="modal-header">
          <div id="title">
            <img src="@/assets/icons/question.svg" />
            <span>Which example best matches your alignment issue?</span>
          </div>
        </h1>
        <div class="modal-content">
          <div id="printing-issues">
            <div class="issue" @click="selectIssue(1)">
              <div class="issue-number"><span>1</span></div>
              <div class="img-wrap">
                <img src="@/assets/printing-assets/issue-1.svg" />
              </div>
              <p>The artwork is smaller than the labels</p>
            </div>
            <div class="issue" @click="selectIssue(2)">
              <div class="issue-number"><span>2</span></div>
              <div class="img-wrap">
                <img src="@/assets/printing-assets/issue-2.svg" />
              </div>
              <p>The artwork is shifted up or down</p>
            </div>
            <div class="issue" @click="selectIssue(3)">
              <div class="issue-number"><span>3</span></div>
              <div class="img-wrap">
                <img src="@/assets/printing-assets/issue-3.svg" />
              </div>
              <p>The artwork is not evenly spaced with the sheet</p>
            </div>
            <div class="issue" @click="selectIssue(4)">
              <div class="issue-number"><span>4</span></div>
              <div class="img-wrap">
                <img src="@/assets/printing-assets/issue-4.svg" />
              </div>
              <p>The artwork is shifted left or right</p>
            </div>
          </div>
        </div>
        <div class="modal-footer" @click="openContact()">
          <p>None of these match my problem ›</p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "TroubleShooting",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const selectIssue = (issueNum: number) => {
      switch (issueNum) {
        case 1: {
          store.dispatch(ActionTypes.SET_MODAL, "smallPage");
          break;
        }
        case 2: {
          store.dispatch(ActionTypes.SET_MODAL, "shiftedVertical");
          break;
        }
        case 3: {
          store.dispatch(ActionTypes.SET_MODAL, "mismatched");
          break;
        }
        case 4: {
          store.dispatch(ActionTypes.SET_MODAL, "alignmentWizard");
          break;
        }
      }
    };

    const openContact = () => {
      store.dispatch(ActionTypes.SET_MODAL, "contact");
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      selectIssue,
      openContact,
    };
  },
});
</script>

<style scoped>
.modal-body {
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  height: 70%;
}

.modal-header {
  color: #000;
  margin-bottom: 1rem;
  padding: 4rem 2rem 0 2rem;
}

#title {
  display: flex;
  align-items: center;
  font-size: 3rem;
}

#title img {
  height: 3rem;
  margin-right: 1rem;
}

.modal-content {
  margin-bottom: 1rem;
}

.modal-content,
.modal-footer {
  font-size: 1.5rem;
}

#printing-issues {
  display: flex;
  justify-content: space-between;
  padding: 2rem 4rem;
}

.issue {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20%;
}

.issue-number {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  left: 10px;
  top: 10px;
  color: #fff;
  border-radius: 50%;
  background: var(--blue) 0% 0% no-repeat padding-box;
  background: #0096ff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
}

.img-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem 0;
  background-color: #fffcaf;
  border: 2px solid transparent;
  border-radius: 6px;
  box-shadow: 0px 0.9px 2px #00000054;
}

.img-wrap img {
  width: 80%;
  height: auto;
}

.issue:nth-child(2) .img-wrap {
  background-color: #e9c2f0;
}

.issue:nth-child(3) .img-wrap {
  background-color: #ff9595;
}

.issue:nth-child(4) .img-wrap {
  background-color: #ffd193;
}

.issue p {
  padding-top: 1rem;
  font-weight: 700;
  text-align: center;
}

.issue:hover .img-wrap {
  border: 2px solid #0096ff;
}

.issue:hover p {
  color: #0096ff;
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0096ff;
  background-color: #f7f9fc;
  padding: 4rem;
  cursor: pointer;
}

@media (max-width: 767px) {
  .modal-header {
    color: #000;
  }

  #title {
    font-size: 2rem;
  }

  .modal-content {
    padding: 2rem;
  }

  #printing-issues {
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .issue {
    padding-bottom: 3rem;
    width: 100%;
  }

  .issue-number {
    left: 25px;
    top: 25px;
  }

  .img-wrap img {
    width: 220px;
  }
}
</style>
